export default {
    headers: { Authorization: `Bearer ${sessionStorage.getItem(process.env.REACT_APP_SESSION_STORAGE_TOKEN)}` }
}
